import api from "../http/api";

// Sem limit explícito o backend aplica o teto diário (ActionItemsController.DailyLimit).
export const getActionItems = async (institutionId, { status, limit } = {}) => {
  try {
    const response = await api.client.get("api/v1/ActionItems", {
      headers: { institutionId },
      params: { status, limit }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar ações recomendadas:", error);
    throw new Error("Falha ao carregar as ações recomendadas");
  }
};

// Resultado das ações (R$ recebido, alunos retidos, rematriculados) abertas ou fechadas nos últimos `days`.
export const getActionOutcomes = async (institutionId, days = 90) => {
  const response = await api.client.get("api/v1/ActionItems/outcomes", {
    headers: { institutionId },
    params: { days }
  });
  return response.data;
};

export const updateActionItemStatus = async (institutionId, id, status) => {
  const response = await api.client.patch(
    `api/v1/ActionItems/${id}/status`,
    { status },
    { headers: { institutionId } }
  );
  return response.data;
};

export const runActionItems = async (institutionId) => {
  const response = await api.client.post("api/v1/ActionItems/run", null, {
    headers: { institutionId }
  });
  return response.data;
};
